import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { ShieldAlert } from 'lucide-react';

export default function LoginPage() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate('/dashboard', { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-[#FFF8F0] flex items-center justify-center p-4" data-testid="login-page">
      <div className="animate-fade-in">
        <Card className="w-[420px] bg-card border-border shadow-sm">
          <CardHeader className="text-center pb-2 pt-8">
            <div className="flex items-center justify-center gap-3 mb-4">
      <div className="w-14 h-14 shrink-0 flex items-center justify-center">
       <img src="/tempust-logo.png" alt="Tempust" className="w-14 h-14 object-contain" />
      </div>
              <span className="text-2xl font-bold text-foreground font-outfit tracking-tight">Tempust</span>
            </div>
            <CardTitle className="text-xl text-foreground font-outfit">Welcome back</CardTitle>
            <CardDescription className="text-muted-foreground">Sign in to manage your editorial workflow</CardDescription>
          </CardHeader>
          <CardContent className="px-8 pb-8 pt-4">
            <Button
              data-testid="google-login-btn"
              onClick={login}
              className="w-full h-12 bg-white hover:bg-[#FFF4E8] text-[#1F1A17] font-medium text-base rounded-lg border border-border shadow-sm transition-all active:scale-[0.98] flex items-center justify-center gap-3"
            >
              <svg width="20" height="20" viewBox="0 0 48 48">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              </svg>
              Continue with Google
            </Button>

            <div className="mt-6 flex gap-3 bg-[#FFF4E8] border border-[#E7D2B8] rounded-lg px-4 py-3">
              <ShieldAlert size={16} className="text-[#9C8E84] shrink-0 mt-0.5" />
              <p className="text-[#6E6258] text-xs leading-relaxed">
                Access to Tempust is by invitation only. Please sign in with your approved email address, otherwise your account will be pending for admin approval.
              </p>
            </div>

            <p className="text-center text-muted-foreground text-sm mt-4">
              Secure authentication powered by Google
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}